import React from 'react'

import { Button, FormattedHTMLMessage } from '@web/walter-ui-kit'
import { lang } from './lang'

interface Props {
    onClose?: () => void
}

// eslint-disable-next-line max-lines-per-function
function About({ onClose }: Props) {
    return (
        <div className="flex flex-col overflow-hidden">
            <FormattedHTMLMessage
                {...lang.title}
                className="text-title-1 px-5 pb-3 text-text-accent bg-background-accent-alpha"
            />
            <div className="flex flex-col gap-6 max-h-full px-5 pt-6 overflow-auto scrollable">
                <FormattedHTMLMessage
                    {...lang.description}
                    className="text-headline text-text-primary [&>span]:text-body [&>span]:text-text-secondary"
                />
            </div>
            <div className="flex flex-col gap-3 mt-8 px-5 pb-5 lg:flex-row">
                <Button dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.gotIt} />
                </Button>
            </div>
        </div>
    )
}

export default About
